import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="discriptionbox-navigator">
            <div className="descriptionbox-nav-box">Description</div>
            <div className="descriptionbox-nav-box fade">Reviews (122)</div>
        </div>
        <div className="descriptionbox-description">
            <p>
                Our collection brings you premium-quality fashion designed for everyday comfort and timeless style. 
                Crafted with carefully selected fabrics, each piece is lightweight, breathable, and gentle on the skin, 
                making it perfect for both casual outings and special occasions. Whether you are dressing up for work, 
                a weekend hangout, or a family gathering, this product blends modern trends with classic appeal. The 
                fine stitching and durable material ensure long-lasting wear, while the versatile design allows easy 
                pairing with different outfits. We believe fashion should not only look good but also feel effortless, 
                which is why our products are tailored to provide the perfect fit for every body type. Discover 
                confidence, comfort, and quality in one package. This is more than clothing—it’s an expression of your 
                personal style. Elevate your wardrobe today with a piece you will love to wear again and again.
            </p>
        </div>
    </div>
  )
}

export default DescriptionBox